import { Pauser } from "./Pauser.js";
export async function loadExternalPauseInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPause", (container) => new Pauser(container), refresh);
}
